import Vue from 'vue';
import Vuex from 'vuex';
import Utils from '@/assets/js/Utils.js';
import chairColors from '@/assets/json/chair_colors';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 現在表示しているユニット、シートのコード(初回表示時の値もここで設定)
    // 選択時に変更される
    currentModel: 'Mu',
    currentUnitCode: 'color-code-white',
    currentSeatCode: 'color-code-waterblue',
    currentSubCategory: '標準シート',
    selectedSubCategory: '標準シート',
    allChairColors: chairColors,
    isSpWidth: false,
  },
  mutations: {
    setModel(state, colors) {
      state.currentModel = colors.model;
    },
    setUnit(state, colors) {
      state.currentUnitCode = colors.code;
    },
    setSeat(state, colors) {
      state.currentSeatCode = colors.code;
    },
    // (SP表示時に)サブカテゴリを切り替えた際に保持する値(表示しない)
    setSubCategory(state, subcategory) {
      state.selectedSubCategory = subcategory;
    },
    // (SP表示時に)表示する、選択している色のサブカテゴリ名
    setCurrentSubCategory(state) {
      state.currentSubCategory = state.selectedSubCategory;
    },
    // widthを基準にSP表示か判定、フラグを設定する
    setWindowSize(state, width) {
      state.isSpWidth = width < 750;
    },
  },
  actions: {
    setModel({ commit }, currentSlide) {
      commit('setModel', { model: currentSlide });
    },
    setUnit({ commit }, colors) {
      commit('setUnit', colors);
    },
    setSeat({ commit }, colors) {
      // シート選択時に表示するサブカテゴリ名を更新する
      commit('setCurrentSubCategory');
      commit('setSeat', colors);
    },
    setSubCategory({ commit }, subcategory) {
      commit('setSubCategory', subcategory);
    },
    setWindowSize({ commit }) {
      commit('setWindowSize', window.innerWidth);
    },
  },
  getters: {
    // 読み込んだjsonを返却
    getColors: (state) =>
      state.allChairColors.find((item) => item.model == state.currentModel)
        .items,
    // jsonから定義済み各色の配列を作成、返却
    getColorsArray: (state) => Utils.getImageFiles(state.allChairColors, true),
    // 判定
    isCurrentUnit: (state) => (color) => state.currentUnitCode === color.code,
    isCurrentSeat: (state) => (color) => state.currentSeatCode === color.code,
    isSp: (state) => state.isSpWidth,
    getAllModels: (state) => state.allChairColors.map((item) => item.model),
    currentUnitCode: (state) => state.currentUnitCode,
    currentSeatCode: (state) => state.currentSeatCode,
    // 現在値取得
    getCurrentModel: (state) => state.currentModel,
    getSubCategory: (state) => state.selectedSubCategory,
    getColorName: (state, getters) => (type) => {
      const obj = {};
      switch (type) {
        case 'unit':
          obj.name = getters.getColorsArray.find(
            (el) => state.currentUnitCode === el.code
          ).name;
          break;
        case 'seat':
          obj.category = state.currentSubCategory;
          obj.name = getters.getColorsArray.find(
            (el) => state.currentSeatCode === el.code
          ).name;
          break;
        default:
          break;
      }
      return obj;
    },
  },
});
